import { Injectable } from '@angular/core';
import { Firestore } from '@angular/fire/firestore';
import { IFermenter } from '../../models/fermenter';
import { dbConst } from './databaseConstants';
import { FirestoreCrudService } from './crudService';
import { AuthService } from '../auth.service';

@Injectable({
  providedIn: 'root'
})
export class FermenterService {

  private crudService: FirestoreCrudService<IFermenter>;

  constructor(
    firestore: Firestore,
    authService: AuthService) {
    this.crudService = new FirestoreCrudService<IFermenter>(firestore, authService, dbConst.fermenters);
  }

  getNewId(): string {
    return this.crudService.getNewId();
  }

  async add(item: IFermenter, id: string | undefined = undefined) {
    return await this.crudService.add(item, id);
  }

  async update(item: IFermenter) {
    const updateItem = { ...item };
    updateItem.beverageId = updateItem.beverageId ? updateItem.beverageId : null;
    updateItem.locationId = updateItem.locationId ? updateItem.locationId : null;
    updateItem.brewfatherBatchId = updateItem.brewfatherBatchId ? updateItem.brewfatherBatchId : null;
    return await this.crudService.update(updateItem);
  }

  async softUpdate(id: string, item: any, uid: string) {
    return await this.crudService.softUpdate(id, item, uid);
  }

  async delete(id: string): Promise<void> {
    return await this.crudService.delete(id);
  }

  getItem(id: string) {
    return this.crudService.get(id);
  }

  getItemOnce(id: string) {
    return this.crudService.getOnce(id);
  }

  getItems(barId: string) {
    return this.crudService.getItemsOrderBy(barId, 'name', undefined);
  }
}
